import { render } from "./VirtualCard.vue?vue&type=template&id=c2511696&scoped=true"
import script from "./VirtualCard.vue?vue&type=script&lang=js"
export * from "./VirtualCard.vue?vue&type=script&lang=js"

import "./VirtualCard.vue?vue&type=style&index=0&id=c2511696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2511696"]])

export default __exports__